import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IGetInboundZoneInventoriesPayload } from '../../../types';

/**
 * This is to track the inventory list based on a zone from the backend.
 */
export const INBOUND_ZONE_INVENTORY_INFO_KEY =
  'inbound-zone-inventory-info-query';

interface IUseInboundZoneInventoryQuery {
  isQueryEnabled?: boolean;
  payload: IGetInboundZoneInventoriesPayload;
}

/**
 * This hook fetches the inbound inventories for a zone from the backend.
 */
export const useInboundZoneInventoryListQuery = ({
  isQueryEnabled = true,
  payload,
}: IUseInboundZoneInventoryQuery) => {
  const { limit, inventoryTransactionId, zone, page } = payload;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    enabled: isQueryEnabled,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      INBOUND_ZONE_INVENTORY_INFO_KEY,
      limit,
      inventoryTransactionId,
      zone,
      page,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    retry: false,
    queryFn: () => INV_MGMT_SERVICE_API.getInboundZoneInventory(payload),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
